import axios from 'axios';
import globals from "../config/appconfig";
import Utils from "../utils/Utils";

export default class SegnalazioniService {

    // static urlSegnalazioni = "http://localhost:8081/api/v1/segnalazioni" //mockup per run locale

    static urlSegnalazioni = globals["app-url-backend-segnalazioni"] + "/sintesisegnalazioni"
    static urlSegnalazioniLIS = globals["app-url-backend-segnalazioni"] + "/sintesisegnalazioniLIS"
    static urlAltreSegnalazioni = globals["app-url-backend-segnalazioni"] + "/sintesisegnalazionipaziente"
    static urlInsertSegnalazione = globals["app-url-backend-segnalazioni"] + "/creazioneschedastandard"
    static urlModificaSegnalazione = globals["app-url-backend-segnalazioni"] + "/{idSegnalazione}"
    static urlGetSegnalazioni = globals["app-url-backend-segnalazioni"] + "/{idSegnalazione}"
    static urlGetSegnalazioniLIS = globals["app-url-backend-segnalazioni"] + "/seganlazioniLis/{idSegnalazione}"
    static urlArchiviaSegnalazione = globals["app-url-backend-segnalazioni"] + "/{idSegnalazione}/archivia"
    static urlConfermaDatiSanitari = globals["app-url-backend-segnalazioni"] + "/{idSegnalazione}/confermadatisanitari"
    static urlConfermaInfo = globals["app-url-backend-segnalazioni"] + "/{idSegnalazione}/confermadatiinfocliepilab"
    static urlConfermaEsito = globals["app-url-backend-segnalazioni"] + "/{idSegnalazione}/confermaesito"
    static urlConfermaDatiSpecifici = globals["app-url-backend-segnalazioni"] + "/{idSegnalazione}/confermadatispecifici"
    static urlConfermaSchedaSpeciale = globals["app-url-backend-segnalazioni"] + "/{idSegnalazione}/confermaschedaspeciale"
    static urlConfermaSchedaSpecialeTbcPolmonare = globals["app-url-backend-segnalazioni"] + "/{idSegnalazione}/confermaesitotbcpolmonare"
    static urlPutAssociaFocolaio = globals["app-url-backend-segnalazioni"] + "/associafocolaio"
    static urlGetMonitoraggio = globals["app-url-backend-segnalazioni"] + "/monitoraggio"
    static urlEsportaFile = globals["app-url-backend-segnalazioni"] + "/monitoraggio/esporta"
    static urlReportEsportaFile = globals["app-url-backend-segnalazioni"] + "/reportStatistici/esporta"
    static urlCaricaPdf = globals["app-url-backend-segnalazioni"] + "/{idSegnalazione}/caricapdf"
    static urlVisualizzaPdf = globals["app-url-backend-segnalazioni"] + "/{idFile}/visualizzapdf"
    static urlInviaPdf = globals["app-url-backend-segnalazioni"] + "/{idSegnalazione}/inviapdf"
    static urlGetAllegati = globals["app-url-backend-segnalazioni"] + "/{idSegnalazione}/tabellapdf"
    static urlNotifica = globals["app-url-backend-segnalazioni"] + "/{utente}/notifica"
    static urlReportStatistici = globals["app-url-backend-segnalazioni"] + "/report"
    static urlGetGraficoReportStatistici = globals["app-url-backend-segnalazioni"] + "/grafico"
    static urlClassificazioneCaso = globals["app-url-backend-segnalazioni"] + "/validazioneCaso"
    static urlModificaStatoSegnalazione = globals["app-url-backend-segnalazioni"] + "/modificaStatoSegnalazione"
    static urlGetTabellaExport = globals["app-url-backend-segnalazioni"] + "/export/tabella"
    static urlRichiediExport = globals["app-url-backend-segnalazioni"] + "/export/richiedi"
    static urlGetFileExportSegnalazioni = globals["app-url-backend-segnalazioni"] + "/export/downloadcsv/{idRichiesta}"
    static urlDeleteRichiestaExport = globals["app-url-backend-segnalazioni"] + "/export/"
    static urlMalattiePremal=globals["app-url-backend-segnalazioni"]+"/malattiePremal"
    static urlInvioMailMonkeypox = globals["app-url-backend-segnalazioni"] + "/{idSegnalazione}/mailMonkeypox"
    static urlContattiMonkeypoxPDF = globals["app-url-backend-segnalazioni"] + "/monkeypoxContattiPDF/{idSegnalazione}"
    static urlManuali = globals["app-url-backend-segnalazioni"] + "/manualeDefCaso"

    static getSegnalazioni(params) {
        let querystring = "?";

        Object.keys(params).forEach(function (key) {
            querystring += key + "=" + params[key] + "&";
        });
        querystring = querystring.substring(0, querystring.length - 1);

        return axios.get(this.urlSegnalazioni + querystring)
    }

    static getSegnalazioniLIS(params) {
        let querystring = "?";

        Object.keys(params).forEach(function (key) {
            querystring += key + "=" + params[key] + "&";
        });
        querystring = querystring.substring(0, querystring.length - 1);

        return axios.get(this.urlSegnalazioniLIS + querystring)
    }

    static getAltreSegnalazioni(params) {
        let querystring = "?";

        Object.keys(params).forEach(function (key) {
            querystring += key + "=" + params[key] + "&";
        });
        querystring = querystring.substring(0, querystring.length - 1);

        return axios.get(this.urlAltreSegnalazioni + querystring)
    }

    static getMonitoraggio(params) {
        let querystring = "?";

        Object.keys(params).forEach(function (key) {
            querystring += key + "=" + params[key] + "&";
        });
        querystring = querystring.substring(0, querystring.length - 1);

        return axios.get(this.urlGetMonitoraggio + querystring)
    }

    static getReportStatisticiExcelPdf(params) {
        return axios.post(this.urlReportEsportaFile, params)
    }

    static getMonitoraggioExcelPdf(params, formato, tipoMonitoraggio) {
        let querystring = "?";

        Object.keys(params).forEach(function (key) {
            if (key !== "size" && key !== "page")
                querystring += key + "=" + params[key] + "&";
        });
        querystring = querystring.substring(0, querystring.length - 1);

        return axios.get(this.urlEsportaFile + querystring + "&" + formato + "&" + tipoMonitoraggio)
    }


    // chiamata per inserire una Segnalazione
    static postInserimentoSegnalazione(jsonInsert) {

        return axios.post(this.urlInsertSegnalazione, jsonInsert)

    }

    // chiamata per modificare una Segnalazione per tutti il primo step del wizard
    static putModificaSegnalazionePrimoStep(jsonInsert, idSegnalazione) {

        return axios.put(this.urlModificaSegnalazione.replace("{idSegnalazione}", idSegnalazione), jsonInsert)

    }

    // chiamata per modificare una Segnalazione per tutti gli step del wizard eccetto il primo
    static putModificaSegnalazione(jsonInsert, idSegnalazione, updateWizardState, segnalazione, showSpinner,
                                   updateFiles) {

        showSpinner(true);
        axios.put(this.urlModificaSegnalazione.replace("{idSegnalazione}", idSegnalazione), jsonInsert).then(data => {
            showSpinner(false);
            if (data && data.status === 200) {
                let segnalazioneSalvata = segnalazione;
                segnalazioneSalvata["stepConfermati"] = data.data.segnalazione.stepConfermati;
                segnalazioneSalvata["idPdf"] = data.data.segnalazione.idPdf;
                segnalazioneSalvata["schedaSpeciale"] = data.data.segnalazione.schedaSpeciale;
                if (data.data.segnalazione.idoneitaPremal) {
                    segnalazioneSalvata["idoneitaPremal"] = data.data.segnalazione.idoneitaPremal;
                }
                let datiCompletiECorretti = Utils.getCompletezzaStep(data.data.segnalazione);

                let files = Array.isArray(data.data.files) ? data.data.files[0] : data.data.files;

                updateFiles(files);

                updateWizardState({
                    segnalazione: segnalazioneSalvata,
                    segnalazioneCopia: segnalazioneSalvata,
                    datiCompletiECorretti: datiCompletiECorretti
                })
            }
        }).catch((reason) => {
            showSpinner(false);
            console.log("[ERROR] put segnalazione " + reason)
        })

    }

    //chiamata per modificare lo stato della segnalazione (archiviazione)
    static postArchiviaSegnalazione(idSegnalazione) {
        return axios.post(this.urlArchiviaSegnalazione.replace("{idSegnalazione}", idSegnalazione));
    }

    static postConfermaDatiSanitari(idSegnalazione, jsonDatiSanitari) {
        return axios.post(this.urlConfermaDatiSanitari.replace("{idSegnalazione}", idSegnalazione), jsonDatiSanitari);
    }

    static postConfermaInfoCliniche(idSegnalazione, jsonInfo) {
        return axios.post(this.urlConfermaInfo.replace("{idSegnalazione}", idSegnalazione), jsonInfo);
    }

    static postConfermaEsito(idSegnalazione, jsonEsito) {
        return axios.post(this.urlConfermaEsito.replace("{idSegnalazione}", idSegnalazione), jsonEsito);
    }

    static postConfermaDatiSpecifici(idSegnalazione, jsonDatiSpecifici) {
        return axios.post(this.urlConfermaDatiSpecifici.replace("{idSegnalazione}", idSegnalazione), jsonDatiSpecifici);
    }

    static postConfermaSchedaSpeciale(idSegnalazione, jsonSchedaSpeciale) {
        return axios.post(this.urlConfermaSchedaSpeciale.replace("{idSegnalazione}", idSegnalazione), jsonSchedaSpeciale);
    }

    static postConfermaSchedaSpecialeTbcpolmonare(idSegnalazione, jsonSchedaSpeciale) {
        return axios.post(this.urlConfermaSchedaSpecialeTbcPolmonare.replace("{idSegnalazione}", idSegnalazione), jsonSchedaSpeciale);
    }

    // chiamata per ottenere una singola Segnalazione
    static getSingolaSegnalazione(idSegnalazione) {
        return axios.get(this.urlGetSegnalazioni.replace("{idSegnalazione}", idSegnalazione))
    }
    // chiamata per ottenere una singola Segnalazione
    static getSingolaSegnalazioneLIS(idSegnalazione) {
        return axios.get(this.urlGetSegnalazioniLIS.replace("{idSegnalazione}", idSegnalazione))
    }

    // associa una segnalazione al focolaio
    static putAssociaFocolaio(idFocolaio, jsonListaFocolai, idSessioneFocolaio) {
        let url = this.urlPutAssociaFocolaio.concat("?idFocolaio=").concat(idFocolaio)
        if (idSessioneFocolaio)
            url = url.concat("&idSessioneFocolaio=").concat(idSessioneFocolaio);

        return axios.put(url, jsonListaFocolai)
    }

    static mapGetSegnalazioni(data) {
        let res = [];

        let m = JSON.parse(sessionStorage.getItem("malattiePerCodice"));
        let aulss = Utils.arrayToMap(JSON.parse(localStorage.getItem("aulss")), "codiceAziendaEsteso");
        if (m) {
            data.data.content.forEach(function (el) {
                el["paziente"] = el.cognome && el.nome ? el.cognome + " " + el.nome : "";
                el["codiceMalattia"] = el.malattia ? m[el.malattia] : el.malattia
                el["timestampCompilazione"] = Utils.transformTimeStampForFrontend(el.timestampCompilazione);
                el.numeroContatti = el.numeroContatti ? el.numeroContatti : 0
                el.malattia = el.malattia ? m[el.malattia] ? m[el.malattia].descrizione : el.malattia : ""
                el.ulssAppartenenza = el.ulssAppartenenza ? aulss[el.ulssAppartenenza].descrizione : el.ulssResidenza? aulss[el.ulssResidenza].descrizione : aulss[el.ulssSegnalazione].descrizione
                //mockup
                const firstDate = new Date(el.dataSegnalazione)
                const secondDate = new Date(Utils.transformDateForBackend(Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp())))

                el["scadenza"] = el["scadenza"] === 1000000 ? "VALIDATA" : el["scadenza"] === 1000001 ? "SCADUTA" : el["scadenza"] !== 1000002 ? el["scadenza"] : ""

                console.log("el: " + el)
                res.push(el);
            })
        }
        if (res.length === 0) {
            return data.data.content
        }

        return res
    }

    static mapGetSegnalazioniLIS(data) {
        let res = [];

        let m = JSON.parse(sessionStorage.getItem("malattiePerCodice"));
        let aulss = Utils.arrayToMap(JSON.parse(localStorage.getItem("aulss")), "codiceAziendaEsteso");
        if (m) {
            data.data.content.forEach(function (el) {
                let mal=el.infoLaboratorio.codiceSirmi.split('-')[0];

                el["paziente"] = el.anagNotificationLis.cognome && el.anagNotificationLis.nome? (el.anagNotificationLis.cognome + " " + el.anagNotificationLis.nome).toUpperCase() : "";
                el["utenteInserimento"] = "LIS"
                el["codiceMalattia"] = mal ? m[mal] : mal
                el["timestampCompilazione"] = Utils.transformTimeStampForFrontend(el.dataSegnalazione);
                el["dataSegnalazione"] = Utils.transformTimeStampForFrontend(el.dataSegnalazione);
                el.malattia =  mal ? m[mal] ? m[mal].descrizione : mal : ""
                el["ulssSegnalazione"] = el.infoLaboratorio.ulss? aulss[el.infoLaboratorio.ulss].descrizione.toUpperCase() : el.infoLaboratorio.ulss.toUpperCase();
                el["statoSegnalazione"] = '04';
                el.ulssAppartenenza = el.ulssDomicilio ? aulss[el.ulssDomicilio].descrizione : el.ulssResidenza? aulss[el.ulssResidenza].descrizione : aulss[el.ulssSegnalazione].descrizione
                if (el.ulssAppartenenza === "ROMA 1" || el.ulssAppartenenza === "ROMA 2")
                    el.ulssAppartenenza = "ROMA 3"
                console.log("el: " + el)
                res.push(el);
            })
        }
        if (res.length === 0) {
            return data.data.content
        }

        return res
    }

    static mapGetSegnalazioniReport(data, intervallo, rapporto) {
        let res = [];
        let m = JSON.parse(sessionStorage.getItem("malattiePerCodice"));

        data.data.content.forEach(function (el) {
            res.push(Utils.mapToGraph(intervallo, rapporto, el, m));
        })
        return res
    }

    static mapColsSegnalazioniReport(data, media, sesso, order, sort, rapporto) {
        let cols = [];
        if (!media)
            delete data["mediaRegionale"];
        if (!sesso || (sesso && rapporto)) {
            delete data["femmineTot"];
            delete data["maschiTot"];
        }
        if (sort) {
            switch (sort) {
                case "65":
                    sort = "≥65";
                    break;
                case "91":
                    sort = "≥91";
                    break;
                case "65.maschi":
                    sort = "≥65.maschi";
                    break;
                case "65.femmine":
                    sort = "≥65.femmine";
                    break;
                case "91.maschi":
                    sort = "≥91.maschi";
                    break;
                case "91.femmine":
                    sort = "≥91.femmine";
                    break;
                default:
                    break;
            }
        }
        Object.keys(data).forEach(function (key) {
            let name = key.replace(/([A-Z])/g, " $1").split("-").join(" - ");
            let malattie = JSON.parse(sessionStorage.getItem("malattiePerCodice"))
            if ("grafico" === key)
                cols.push({key: key, name: "", tipo: "linkButton", path: "", nomeParametro: "grafico"})
            else if ("malattia" === key)
                cols.push({
                    key: key,
                    name: name.charAt(0).toUpperCase() + name.slice(1),
                    sortDirection: "none",
                    tipo: "dizionario",
                    oggetto: malattie,
                    campo: "descrizione"
                })

            else if (!(cols.includes({key: key, name: key.charAt(0).toUpperCase() + key.slice(1, -1)} || {
                key: key,
                name: key.charAt(0).toUpperCase() + key.slice(1)
            }))) {
                if ("M" === key.slice(-1) || "F" === key.slice(-1))
                    cols.push({key: key, name: name.charAt(0).toUpperCase() + name.slice(1, -1), sortDirection: "none"})
                else
                    cols.push({key: key, name: name.charAt(0).toUpperCase() + name.slice(1), sortDirection: "none"})
            }

        });
        if (order) {
            sort = sort.includes(".femmine") ? sort.replace(".femmine", "F") : sort.includes(".maschi") ? sort.replace(".maschi", "M") : sort === "maschi" ? "maschiTot" : sort === "femmine" ? "femmineTot" : sort
            if (sort === "2-2F" || sort === "2-2M" || sort === "2-2") {
                sort = sort.replace("2-2", "2mesi-2anni")
            }
            cols.find(x => x.key === sort).sortDirection = order
        }

        return cols
    }

    static postCaricaPdf(idSegnalazione, file) {
        return axios.post(this.urlCaricaPdf.replace("{idSegnalazione}", idSegnalazione), file, {
            headers: {
                'Content-Type': 'application/base64'
            }
        });
    }

    static getAllegati(idSegnalazione) {
        return axios.get(this.urlGetAllegati.replace("{idSegnalazione}", idSegnalazione));
    }

    static getPdf(idPdf) {
        return axios.get(this.urlVisualizzaPdf.replace("{idFile}", idPdf));
    }

    static postInviaPdf(idSegnalazione) {
        return axios.post(this.urlInviaPdf.replace("{idSegnalazione}", idSegnalazione));
    }

    static getNotifica(utente) {
        return axios.get(this.urlNotifica.replace("{utente}", utente));
    }

    static getReportStatistici(params, json) {
        let querystring = "?";

        Object.keys(params).forEach(function (key) {
            if (params[key] != undefined) querystring += key + "=" + params[key] + "&";
        });
        querystring = querystring.substring(0, querystring.length - 1);

        return axios.post(this.urlReportStatistici + querystring, json)
    }

    static getGraficoReportStatistici(params) {

        let querystring = "?";
        Object.keys(params).forEach(function (key) {
            querystring += key + "=" + params[key] + "&";
        });
        querystring = querystring.substring(0, querystring.length - 1);

        return axios.get(this.urlGetGraficoReportStatistici + querystring)
    }

    static getClassificazioneCaso(params) {
        let urlValidazioneCaso = this.urlClassificazioneCaso + "?codiceMalattia=" + params.codiceMalattia
        if (params.infoCliniche != null && params.infoCliniche.length > 0) {
            params.infoCliniche.forEach(info => {
                urlValidazioneCaso = urlValidazioneCaso.concat("&infoCliniche=").concat(info.toString())
            })
        }
        if (params.infoEpidemiologiche != null && params.infoEpidemiologiche.length > 0) {
            params.infoEpidemiologiche.forEach(info => {
                urlValidazioneCaso = urlValidazioneCaso.concat("&infoEpidemiologiche=").concat(info.toString())
            })
        }
        if (params.infoLaboratorio != null && params.infoLaboratorio.length > 0) {
            params.infoLaboratorio.forEach(info => {
                urlValidazioneCaso = urlValidazioneCaso.concat("&infoLaboratorio=").concat(info.toString())
            })
        }
        return axios.get(urlValidazioneCaso)
    }

    static putStatoSegnalazione(params) {
        let querystring = "?";
        Object.keys(params).forEach(function (key) {
            querystring += key + "=" + params[key] + "&";
        });
        querystring = querystring.substring(0, querystring.length - 1);
        return axios.put(this.urlModificaStatoSegnalazione + querystring)
    }

    static getTabellaExport(params) {
        let querystring = "?";

        Object.keys(params).forEach(function (key) {
            if (params[key]!=null)
            querystring += key + "=" + params[key] + "&";
        });
        querystring = querystring.substring(0, querystring.length - 1);

        return axios.get(this.urlGetTabellaExport + querystring)
    }

    static richiestaExportSegnalazioni(params) {
        let querystring = "?";

        Object.keys(params).forEach(function (key) {
            querystring += key + "=" + params[key] + "&";
        });
        querystring = querystring.substring(0, querystring.length - 1);

        return axios.post(this.urlRichiediExport, params)
    }

    static getFileExportSegnalazioni(idRichiesta) {
        return axios.get(this.urlGetFileExportSegnalazioni.replace("{idRichiesta}", idRichiesta));
    }

    static deleteRichiestaExportSegnalazioni(idRichiesta) {
        return axios.delete(this.urlDeleteRichiestaExport + idRichiesta);
    }

    static getMalattiePremal() {
        return axios.get(this.urlMalattiePremal);
    }

    static getContattiMonkypoxPDF(idSegnalazione) {
        return axios.get(this.urlContattiMonkeypoxPDF.replace("{idSegnalazione}", idSegnalazione));
    }

    
    static getContattiMonkypoxCSV(idSegnalazione) {
        return axios.get(this.urlContattiMonkeypoxPDF.replace("{idSegnalazione}", idSegnalazione)+"?formato=xlsx");
    }

    
    static invioMailMonkeypox(idSegnalazione) {
        return axios.post(this.urlInvioMailMonkeypox.replace("{idSegnalazione}", idSegnalazione));
    }

    static getManuali(params){

        let querystring = "?idFile=" + params;

        return axios.get(this.urlManuali + querystring)
    }
}
